<template>
  <v-container class="content-font-size pt-0" :style="rowWidth" fluid>
    <div class="background-color-white mb-3 mb-sm-6 mr-sm-0 rounded-lg">
      <v-col cols="12" class="my-5">
        <v-row
          :justify="'space-between'"
          class="font-24 header-text mt-3 main-header mb-2 mx-2"
        >
          <v-col cols="4"> Store Clubs </v-col>
        </v-row>
        <v-row class="pb-1">
          <v-col cols="12" class="header-text ml-5"> Available Rewards </v-col>
        </v-row>
        <v-row class="mt-0 pt-0 py-5">
          <v-col cols="12" class="click-to-see-rewards ml-5 pt-0">
            <span v-if="availableRewards().length"
              >Click to see rewards you can redeem right now</span
            >
            <span v-else>No rewards available</span>
          </v-col>
        </v-row>
        <RewardsTabs
          type="clubs"
          :clubs="availableRewards()"
          :redeemable="true"
        />

        <v-row class="pb-1">
          <v-col cols="12" class="header-text ml-5"> In progress clubs </v-col>
        </v-row>
        <v-row class="mt-0 pt-0 py-5">
          <v-col cols="12" class="click-to-see-rewards ml-5 pt-0">
            <span v-if="inProgressClubs().length"
              >Click to see rewards you can redeem after completing the
              club</span
            >
            <span v-else>No in progress clubs</span>
          </v-col>
        </v-row>
        <RewardsTabs type="clubs" :clubs="inProgressClubs()" />

        <v-row class="pb-1">
          <v-col cols="12" class="header-text ml-5"> Other clubs </v-col>
        </v-row>
        <v-row class="mt-0 pt-0 py-5">
          <v-col cols="12" class="click-to-see-rewards ml-5 pt-0">
            <span v-if="otherClubs().length"
              >Click to see rewards you can redeem if you buy items in the
              club</span
            >
            <span v-else>No other clubs available</span>
          </v-col>
        </v-row>
        <RewardsTabs type="clubs" :clubs="otherClubs()" />
      </v-col>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import RewardsTabs from "./Tabs.vue";
export default {
  name: "RewardsClubs",
  components: {
    RewardsTabs,
  },
  computed: {
    ...mapGetters("store", {
      clubs: "clubs",
    }),
    rowWidth() {
      return this.$vuetify.breakpoint.xsOnly ? "width: 100vw" : "";
    },
  },
  methods: {
    availableRewards() {
      return this.clubs.filter((c) => c.free_products_qty > 0);
    },
    inProgressClubs() {
      return this.clubs.filter(
        (c) => c.free_products_qty == 0 && c.stars_in_this_cycle > 0,
      );
    },
    otherClubs() {
      return this.clubs.filter(
        (c) => c.free_products_qty == 0 && c.stars_in_this_cycle == 0,
      );
    },
  },
};
</script>

<style scoped></style>
